<ion-header>
  <ion-toolbar>
    <ion-title>
      <div class="modal-title">
        <ion-icon name="log-out-outline" class="title-icon"></ion-icon>
        Sign Out
      </div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        (click)="cancelLogout()"
        [disabled]="isLoggingOut"
        aria-label="Close logout modal">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="logout-modal-content">
  <div class="modal-container" [@slideInUp]>

    <!-- User Avatar & Info Section -->
    <div class="user-info-section" [@fadeInScale]>
      <div class="user-avatar">
        <ion-icon name="person-circle" class="avatar-icon"></ion-icon>
      </div>
      <div class="user-details">
        <h2 class="user-name">{{ userName }}</h2>
        <p class="user-email" *ngIf="userEmail">{{ userEmail }}</p>
      </div>
    </div>

    <!-- Warning/Info Section -->
    <div class="warning-section">
      <div class="warning-card" [ngClass]="{ 'has-changes': hasUnsavedChanges }">
        <div class="warning-header">
          <ion-icon
            [name]="hasUnsavedChanges ? 'warning' : 'information-circle'"
            class="warning-icon">
          </ion-icon>
          <h3 class="warning-title">
            {{ hasUnsavedChanges ? 'Unsaved Changes' : 'Confirm Sign Out' }}
          </h3>
        </div>

        <div class="warning-content">
          <p class="warning-message">{{ getLogoutMessage() }}</p>
          <div class="info-items">
            <div class="info-item">
              <ion-icon name="time-outline" class="info-icon"></ion-icon>
              <span>{{ getTimeEstimate() }}</span>
            </div>
            <div class="info-item">
              <ion-icon name="shield-checkmark-outline" class="info-icon"></ion-icon>
              <span>Your data will remain secure and accessible after signing back in</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons Section -->
    <div class="action-buttons">
      <!-- Save and Logout Option (if has unsaved changes) -->
      <ion-button
        *ngIf="hasUnsavedChanges"
        expand="block"
        fill="solid"
        color="success"
        class="action-button save-logout-button"
        (click)="saveAndLogout()"
        [disabled]="isLoggingOut">
        <ion-icon name="save-outline" slot="start"></ion-icon>
        <span *ngIf="!isLoggingOut">Save & Sign Out</span>
        <span *ngIf="isLoggingOut">Saving...</span>
      </ion-button>

      <!-- Primary Logout Button -->
      <ion-button
        expand="block"
        fill="solid"
        color="danger"
        class="action-button logout-button"
        (click)="confirmLogout()"
        [disabled]="isLoggingOut">
        <ion-icon name="log-out-outline" slot="start"></ion-icon>
        <span *ngIf="!isLoggingOut">
          {{ hasUnsavedChanges ? 'Sign Out Without Saving' : 'Sign Out' }}
        </span>
        <span *ngIf="isLoggingOut">Signing out...</span>
      </ion-button>

      <!-- Cancel Button -->
      <ion-button
        expand="block"
        fill="clear"
        color="medium"
        class="action-button cancel-button"
        (click)="cancelLogout()"
        [disabled]="isLoggingOut">
        <ion-icon name="arrow-back-outline" slot="start"></ion-icon>
        Stay Signed In
      </ion-button>
    </div>

    <!-- Security Notice -->
    <div class="security-notice">
      <ion-icon name="lock-closed-outline" class="security-icon"></ion-icon>
      <p class="security-text">
        For your security, we recommend signing out on shared devices.
      </p>
    </div>
  </div>
</ion-content>